import React from 'react';
import {
  Col, Container, Row, Card, CardBody,
} from 'reactstrap';
import { SiteName } from '../../../shared/components/domainSupport';

const OAuthPage = ({ adPlatform = 'API' }) => {
  const supportText = SiteName() === 'Limitless' ? <h4>For onboarding support, please contact <a href="mailto:adteam@limitless.tech">adteam@limitless.tech</a></h4> : '';
  const urlParams = new URLSearchParams(window.location.search);

  // Success parameters
  const paramCode = urlParams.get('code');
  const paramScope = urlParams.get('scope');
  const paramState = urlParams.get('state');

  // Error parameters
  const paramError = urlParams.get('error');
  const paramErrorDescription = urlParams.get('error_description');
  const paramErrorUri = urlParams.get('error_uri');

  // Admin consent parameters (Microsoft-specific)
  const paramAdminConsent = urlParams.get('admin_consent');
  const paramTenant = urlParams.get('tenant');

  // Determine response type
  const isError = paramError !== null;
  const isAdminConsent = paramAdminConsent === 'True';

  // Format platform name for display
  const platformName = adPlatform.charAt(0).toUpperCase() + adPlatform.slice(1);

  // TODO: This URL should come from an API call in the future
  const microsoftAuthUrl = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=050e9093-b32d-448d-a730-2aacdba081d4&response_type=code&redirect_uri=http://dashboard.limitless.tech/onboarding/oauth/microsoft&response_mode=query&scope=https://ads.microsoft.com/msads.manage offline_access&prompt=consent&state=1';

  // Render admin consent success view
  const renderAdminConsent = () => (
    <>
      <h4 className="text-success">Tenant Admin Consent Granted ✓</h4>
      <p>Your organization has successfully granted admin consent for this application.</p>
      <br />
      <Card>
        <CardBody>
          <h5 className="bold-text">Consent Details:</h5>
          <p><strong>Admin Consent:</strong> <span className="text-success">Granted</span></p>
          {paramTenant && (
            <p><strong>Tenant ID:</strong> {paramTenant}</p>
          )}
        </CardBody>
      </Card>
      <br />
      <h4>Next Step: Authorize Your Account</h4>
      <p>Now that your tenant admin has granted consent, please click the button below to authorize your Microsoft Advertising account:</p>
      <br />
      <div className="text-center">
        <a
          href={microsoftAuthUrl}
          className="btn btn-primary btn-lg"
          style={{ color: '#fff', fontWeight: 'bold' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Authorize Microsoft Advertising Account
        </a>
      </div>
      <br />
      <Card>
        <CardBody className="bg-light">
          <p className="text-muted small mb-0">
            <strong>Note:</strong> The authorization URL above is currently hardcoded for testing.
            In production, this URL will be dynamically generated by the API.
          </p>
        </CardBody>
      </Card>
      <br />
      {supportText}
    </>
  );

  // Render success view
  const renderSuccess = () => (
    <>
      <h4>This flow can be used to initiate onboarding or to renew your authorization on an existing account. We will verify the information and either assign it to an existing account or create a new account.</h4>
      <br />
      <Card>
        <CardBody>
          <h5 className="bold-text">Authorization Details:</h5>
          {paramCode && (
            <p><strong>Code:</strong> {paramCode}</p>
          )}
          {paramScope && (
            <p><strong>Scope:</strong> {paramScope}</p>
          )}
          {paramState && (
            <p><strong>State:</strong> {paramState}</p>
          )}
          {!paramCode && !paramScope && (
            <p className="text-muted">No authorization parameters found in the URL.</p>
          )}
        </CardBody>
      </Card>
      <br />
      {supportText}
      <br />
      <h4>Thank You</h4>
    </>
  );

  // Render error view
  const renderError = () => (
    <>
      <h4 className="text-danger">Authorization Error</h4>
      <p>There was an error during the OAuth authorization process. Please review the details below:</p>
      <br />
      <Card>
        <CardBody>
          <h5 className="bold-text text-danger">Error Details:</h5>
          {paramError && (
            <p><strong>Error:</strong> <span className="text-danger">{paramError}</span></p>
          )}
          {paramErrorDescription && (
            <div>
              <p><strong>Description:</strong></p>
              <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {decodeURIComponent(paramErrorDescription)}
              </p>
            </div>
          )}
          {paramErrorUri && (
            <p>
              <strong>Error URI:</strong>{' '}
              <a href={paramErrorUri} target="_blank" rel="noopener noreferrer">
                {paramErrorUri}
              </a>
            </p>
          )}
          {paramState && (
            <p><strong>State:</strong> {paramState}</p>
          )}
        </CardBody>
      </Card>
      <br />
      {supportText}
      <br />
      <h4>Next Steps</h4>
      <p>Please contact support with the error details above to resolve this issue.</p>
    </>
  );

  // Determine which view to render
  let content;
  if (isAdminConsent) {
    content = renderAdminConsent();
  } else if (isError) {
    content = renderError();
  } else {
    content = renderSuccess();
  }

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">{platformName} OAuth - API Onboarding and Maintenance</h3>
        </Col>
      </Row>
      <Row>
        <br />
      </Row>
      <Row>
        <Col md={12}>
          <div className="account__wrapper">
            {content}
          </div>
        </Col>
      </Row>
      <Row>
        <br />
      </Row>
    </Container>
  );
};

export default OAuthPage;
